import { Box, Grid, styled, Typography } from "@mui/material";
import { useState } from "react";
import { allImages } from "../../../assets";
import GlobalButton from "../../../components/CustomButton";
import SnackbarAlert from "../../../components/SnackBar";
import CustomerSupportDialog from "../customerSupport";
import { customerSupport } from "../../../services/Suport";
import Loader from "../../../components/Loader";
import { isLight } from "@amcharts/amcharts5/.internal/core/util/Utils";

const MainView = styled(Box)(({ theme }) => ({
  position: "relative",
  backgroundColor: "#ffffff",
  maxWidth: "1200px",
  margin: "auto",
  padding: "16px",

  "& .lpl_rs_pr": {
    fontSize: "2.5rem",
    fontWeight: 700,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "2rem",
    },
  },
  "& .lpl_rs_sr": {
    fontSize: "1.8rem",
    fontWeight: 600,
    color: "#161C2D",
    [theme.breakpoints.down("sm")]: {
      fontSize: "1.5rem",
    },
  },
}));

function YoutubeVideo() {
  // State to control popup
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [snackbarProps, setSnackbarProps] = useState({
    open: false,
    type: "",
    message: "",
  });
  // Form data state
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  // Open dialog
  const handleOpen = () => setOpen(true);

  // Close dialog and reset form
  const handleClose = () => {
    setOpen(false);
    resetForm();
  };

  // Reset form fields
  const resetForm = () => {
    setForm({
      name: "",
      email: "",
      phone: "",
      message: "",
    });
  };

  // Handle form field change
  const handleChange = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  // Handle form submit
  const handleSubmit = async (e) => {
    try {
      if (e) e.preventDefault();

      const { name, email, phone, message } = form;
      if (!name || !email || !phone || !message) {
        handleSnackbarVal(true, "error", "All fields are required.");
        return;
      }
      setIsLoading(true);
      const responce = await customerSupport({
        name,
        email,
        phone,
        message,
      });
      setIsLoading(false);

      if (responce?.status === 200 || responce?.status === 201) {
        handleSnackbarVal(true, "success", responce?.data?.message);
      } else {
        handleSnackbarVal(true, "error", responce?.data?.message);
      }

      handleClose();
    } catch (error) {
      console.log(error, "errorerrorerrorerror124656");

      setIsLoading(true);
    }
  };
  const handleSnackbarVal = (open, type, message) => {
    setSnackbarProps({
      open,
      type,
      message,
    });
  };

  const handleCloseSnackbar = () => {
    handleSnackbarVal(false, "", "");
  };

  return (
    <MainView my={{ xs: 3, md: 8 }}>
      <Grid
        container
        spacing={{ xs: 2, md: 4 }}
        flexWrap={"wrap-reverse"}
        alignItems={"center"}
      >
        <Grid item xs={12} md={6}>
          <Typography variant="h1" className="lpl_rs_pr">
            Our YouTube Channel
          </Typography>

          <Typography
            mt={1.5}
            fontWeight={300}
            variant="body1"
            color={"#161C2D"}
            lineHeight={1.7}
          >
            Begin by importing your client database or adding new contacts
            manually. Organize contacts into categories such as leads,
            prospects, and loyal customers for targeted outreach. Track
            interactions including calls, emails, and meetings to maintain a
            comprehensive view of client history. Leverage automation tools for
            tasks like follow-ups and reminders, ensuring timely communication.
          </Typography>

          <GlobalButton
            btnText={"Contact us"}
            handleClickBtn={handleOpen} // ✅ Open dialog on click
            styleProps={{
              mt: 2.5,
              height: 45,
              width: { xs: "100%", sm: 200 },
            }}
          />
        </Grid>

        <Grid item xs={12} md={6}>
          <img
            src={allImages.landingAboutUsVimage}
            alt={"image"}
            width={"100%"}
          />
        </Grid>
      </Grid>

      {/* ✅ Customer Support Popup */}
      <CustomerSupportDialog
        open={open}
        onClose={handleClose}
        form={form}
        onChange={handleChange}
        onSubmit={handleSubmit}
      />
      <SnackbarAlert
        handleCloseSnackbar={handleCloseSnackbar}
        snackbarProps={snackbarProps}
      />
      <Loader isLoading={isLoading} />
    </MainView>
  );
}

export default YoutubeVideo;
